import { EnumOption } from './enum-option';

/** Mirrors GIP.CM.Domain.TaskHistoryType */
export const TaskHistoryType = {
  Assign: 0,
  Approve: 1,
  Reject: 2,
  Reassigned: 3,
  Update: 4,
  Cancel: 5,
} as const;

export type TaskHistoryTypeValue = (typeof TaskHistoryType)[keyof typeof TaskHistoryType];

export const TaskHistoryTypeList: EnumOption[] = [
  { value: TaskHistoryType.Assign, label: 'Assign' },
  { value: TaskHistoryType.Approve, label: 'Approve' },
  { value: TaskHistoryType.Reject, label: 'Reject' },
  { value: TaskHistoryType.Reassigned, label: 'Reassigned' },
  { value: TaskHistoryType.Update, label: 'Update' },
  { value: TaskHistoryType.Cancel, label: 'Cancel' },
];

export function getTaskHistoryTypeLabel(value: number | null | undefined): string {
  return TaskHistoryTypeList.find((o) => o.value === value)?.label ?? '—';
}
